export const certificationInstallments = [
  {
    label: "(11% Off) Pago de Contado $22,500 MXN / $1,350 USD aprox.",
    description:
      "Disponible para Tarjetas de Crédito o Débito Internacionales.",
    installments: 1,
  },
  {
    label: "3 Meses Sin Intereses ($25,000 MXN) / $1,500 USD aprox",
    installments: 3,
    description: "Sólo disponible para Tarjetas de Crédito Mexicanas.",
  },
];

export const summitInstallments = [
    {
      label: "(11% Off) Pago de Contado $16,000 MXN",
      description:
        "Disponible para Tarjetas de Crédito o Débito Internacionales.",
      installments: 1,
    },
    {
      label: "3 Meses Sin Intereses $17,900 MXN",
      installments: 3,
      description: "Sólo disponible para Tarjetas de Crédito Mexicanas.",
    },
  ];
  